import { Form, Input, message, Modal, Switch } from "antd";
import { useState } from "react";
import ManageBinService from "../../../services/ManageBinService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const AddBin = ({ userData, addBinModal, setIsModalOpen, onAddBin }) => {
    const [form] = Form.useForm();
    const [status, setStatus] = useState('Active');

    const handleChange = (checked) => {
        const newStatus = checked ? 'Active' : 'In-Active';
        setStatus(newStatus);
    };

    const handleSubmit = async (values) => {
        try {
            // Prepare form data for submission
            const formData = {
                ...values,
                bin_status: status,
                bin_added_by: userData.su_id,
            };
    
            // Log the form data for debugging
            console.log("Form Data:", formData);
    
            // Send form data to service
            const response = await ManageBinService.add_bin(formData);
            
            // Handle success and trigger additional actions
            console.log("Server Response:", response);
            ResponseMessage.success({ message: response.message })
            onAddBin(formData);
            setIsModalOpen(false);
        } catch (error) {
            console.log("Error submitting form:", error);
            ResponseMessage.error({ message : error });
        }
    };
    

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Modal
            title="Add New Bin"
            open={addBinModal}
            onOk={() => form.submit()}
            onCancel={handleCancel}
            okText="Submit"
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={handleSubmit}
            >
                <Form.Item
                    label="Enter Bin Name"
                    name="bin_name"
                    rules={[{ required: true, message: "Please enter the bin name!" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Enter Capacity in Kgs"
                    name="bin_capacity"
                    rules={[
                        { required: true, message: "Please enter the capacity!" },
                        { pattern: /^[0-9]+$/, message: "Capacity must be a number!" },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    required
                    label="Status"
                    name="bin_status"
                >
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="In-Active"
                        defaultChecked
                        onChange={handleChange}
                    />
                </Form.Item>

            </Form>
        </Modal>
    );
};

export default AddBin;
